import Vue from 'vue';
/**
 * @param  {string} value 文件名称
 * @return {string} 参数值
 */
export default Vue.filter('removeFileSuffix', function (value: string) {
    if (!value) {
        return '';
    }

    return value.replace(/\.(xls|xlsx)$/, '');
});
